import { render, staticRenderFns } from "./spa.vue?vue&type=template&id=3ce7f812&"
import script from "./spa.vue?vue&type=script&lang=js&"
export * from "./spa.vue?vue&type=script&lang=js&"
import style0 from "./spa.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports